var map = {
	"./base/software-engineering.md": 87084,
	"./concept/complexity.md": 1764,
	"./concept/data-structure-and-algorithm.md": 97300,
	"./concept/internet.md": 18757,
	"./concept/ood.md": 17960,
	"./concept/operating-system.md": 94883,
	"./concept/system-design.md": 83436,
	"./dsa/array.md": 31275,
	"./dsa/dynamic-programming.md": 19655,
	"./dsa/graph.md": 85006,
	"./dsa/greedy_algorithm.md": 6470,
	"./dsa/hash-table.md": 20825,
	"./dsa/heap.md": 26358,
	"./dsa/linked-list.md": 57382,
	"./dsa/queue.md": 32953,
	"./dsa/quick-sort.md": 91418,
	"./dsa/solve-problem.md": 62467,
	"./dsa/sorting.md": 50838,
	"./dsa/stack.md": 83622,
	"./dsa/tree.md": 98344,
	"./dsa/tries.md": 15291,
	"./express.md": 44929,
	"./react.md": 3098,
	"./react/2021-06-16-state.md": 55593,
	"./react/2021-06-17-other.md": 13465,
	"./react/2021-07-19-React-Tenesorflow.md": 37444,
	"./react/2021-10-15-signup-login.md": 11922,
	"./react/2023-02-18-node-graph.md": 92219,
	"./react/2023-04-15-search-bar.md": 64225,
	"./react/api.md": 429,
	"./react/component.md": 90266,
	"./react/hook.md": 30778,
	"./react/router.md": 44436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98407;